/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import Modal from "../components/Modal";

import { useModalStore } from "../stores/hooks";

import { SMS_MESSAGES } from "../utils/message";
import { sendSmsMessage } from "../utils/postMessages";

const MessageItem = ({ active, message, label, onSelect }) => {
  const handleSelect = () => {
    onSelect(message);
  };

  return (
    <div>
      <label className="block mb-10 text-16" onClick={handleSelect}>
        <input
          type="radio"
          name="corp"
          defaultChecked={!!active}
          className="mr-5"
        />
        {label}
      </label>
    </div>
  );
};

function SendMessageModal({
  mobile,
  type,
  messageForAddress = null,
  messageForVehicle = null,
  hasVehicle = false,
  bookId,
}) {
  const { closeModal } = useModalStore();

  const { register, handleSubmit, reset, setValue, watch } = useForm();

  const [load, setLoad] = useState(false);

  useEffect(() => {
    reset({
      message: messageForVehicle || messageForAddress || SMS_MESSAGES[0],
    });

    setLoad(true);
  }, [messageForAddress, messageForVehicle]);

  const handleSelectMessage = (message) => {
    setValue("message", message);
  };

  const handleCancel = () => {
    closeModal();
  };

  const onSubmit = ({ message }) => {
    // 등록된 차량이 없는데 차량등록요청 문자를 보내려는 경우 발송을 막는다
    if (message === messageForVehicle && !hasVehicle) {
      window.alert("등록된 차량번호가 없어 문자를 발송할 수 없습니다.");
      return;
    }

    sendSmsMessage({ mobile, message, bookId });

    closeModal();
  };

  return (
    <Modal>
      <div className="p-15">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-20">
            <h5 className="font-medium text-18 mb-10">{mobile}</h5>
            <div>
              {messageForVehicle && (
                <MessageItem
                  key={messageForVehicle}
                  active={messageForVehicle === watch("message")}
                  message={messageForVehicle}
                  label="[택배차량등록요청문자발송]"
                  onSelect={handleSelectMessage}
                />
              )}
              {messageForAddress && (
                <MessageItem
                  key={messageForAddress}
                  active={messageForAddress === watch("message")}
                  message={messageForAddress}
                  label="[주소요청문자발송]"
                  onSelect={handleSelectMessage}
                />
              )}
              {load &&
                SMS_MESSAGES.map((message) => {
                  return (
                    <MessageItem
                      key={message}
                      active={message === watch("message")}
                      message={message}
                      label={message}
                      onSelect={handleSelectMessage}
                    />
                  );
                })}
              <input name="message" {...register("message")} hidden />
            </div>
          </div>
          <div className="flex justify-center items-center">
            <button
              type="button"
              className="text-16 flex-1 p-10"
              onClick={handleCancel}
            >
              닫기
            </button>
            <button type="submit" className="text-16 text-orange flex-1 p-10">
              보내기
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
}

export default SendMessageModal;
